import { useHandler } from "@redotech/react-util/hook";
import RefreshIcon from "@redotech/redo-icons/featured-refresh-cw-3.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { ReconcileSupportV2Modal } from "./reconcile-support-v2-modal";
import { RECONCILE_JOB_SUMMARY } from "./support-v2-maintenance-options";

export const ReconcileSupportV2Card = memo(function ReconcileSupportV2Card({
  teamId,
}: {
  teamId: string;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = useHandler(() => setModalOpen(true));
  const closeModal = useHandler(() => setModalOpen(false));

  return (
    <>
      <Card borderRadius="md" title="Reconcile support-v2 tickets">
        <Flex dir="column" gap="lg" w="full">
          <Text fontSize="sm" textColor="secondary">
            {RECONCILE_JOB_SUMMARY}
          </Text>
          <Flex align="center" gap="sm" wrap="wrap">
            <RedoButton
              hierarchy="primary"
              IconLeading={RefreshIcon}
              onClick={openModal}
              text="Open reconcile"
            />
          </Flex>
        </Flex>
      </Card>

      {modalOpen && (
        <ReconcileSupportV2Modal onClose={closeModal} teamId={teamId} />
      )}
    </>
  );
});
